import { TableHeadCell, TableRow } from '@ovComponents/2-component/table/table';
import { PORTFOLIO_COLUMN_WIDTH } from '@ovComponents/4-module/widgets/portfolio/components/utils';
import { useTranslation } from 'react-i18next';

// The left and right tables are separate, so their header rows only line up
// when both are held to the height of a three-line account header.
export const ACCOUNT_ALLOCATION_HEAD_HEIGHT = '72px';

const HEAD_CELL_SX = { height: ACCOUNT_ALLOCATION_HEAD_HEIGHT };

export type AccountAllocationLeftHeadProp = {
  isAssetClassPortfolio: boolean;
  // Row heights are aligned row by row across the two tables, so when the
  // account columns add a second header row this side needs one too.
  withSubHeadRow?: boolean;
};

export const AccountAllocationLeftHead = ({
  isAssetClassPortfolio,
  withSubHeadRow = false,
}: AccountAllocationLeftHeadProp) => {
  const { t } = useTranslation('components');
  const rowSpan = withSubHeadRow ? 2 : undefined;

  return (
    <>
      <TableRow>
        {isAssetClassPortfolio && (
          <TableHeadCell
            rowSpan={rowSpan}
            sx={{
              ...HEAD_CELL_SX,
              width: PORTFOLIO_COLUMN_WIDTH.expand,
              padding: 0,
            }}
          />
        )}
        {isAssetClassPortfolio && (
          <TableHeadCell
            rowSpan={rowSpan}
            sx={{
              ...HEAD_CELL_SX,
              minWidth: PORTFOLIO_COLUMN_WIDTH.assetGroup,
            }}
          >
            {t('portfolioTable.assetGroup')}
          </TableHeadCell>
        )}
        <TableHeadCell
          rowSpan={rowSpan}
          sx={{ ...HEAD_CELL_SX, minWidth: PORTFOLIO_COLUMN_WIDTH.security }}
        >
          {t('portfolioTable.security')}
        </TableHeadCell>
        <TableHeadCell
          rowSpan={rowSpan}
          sx={{ ...HEAD_CELL_SX, minWidth: PORTFOLIO_COLUMN_WIDTH.security }}
          number
        >
          {t('accountAllocationGrid.householdTargetColumn')}
        </TableHeadCell>
        <TableHeadCell
          rowSpan={rowSpan}
          sx={{ ...HEAD_CELL_SX, minWidth: PORTFOLIO_COLUMN_WIDTH.security }}
          number
        >
          {t('accountAllocationGrid.householdActualColumn')}
        </TableHeadCell>
      </TableRow>
      {withSubHeadRow && <TableRow />}
    </>
  );
};
